const monitoringTranslation = {
  mode: 'ko',
  menu: '종합 모니터링',

  totalUpload: '총 업로드',
  currentStatus: '상태',
  videoDevice: '캡쳐보드',
  videoDeviceStatus: '비디오 장치 상태',
  activity: '활동',
  scan: '스캔',

  start: '프로그램시작',
  nosess: '대기중',
  session: '모션감지중',
  recording: '녹화중',
  paused: '일시정지',
  exit: '프로그램종료',

  // v3 상태
  created: '부팅중',
  initializing: '초기화중',
  standby: '대기중',
  motion_detection: '모션감지중',
  warn: '경고',
  notice: '주의',

  lsHdml: '구캡',
  lsEasyCap: '이지캡',
  yuh01: '신캡',
  gameDockUltra: '게임독 울트라',
  yux13: '신신캡',
  asus: 'ASUS캡',
  unknown: '알수없음',

  hdmlYuyv422: 'HDMI/YUYV422',
  hdmlMjpeg: 'HDMI/MJPEG',
  analog: '아날로그',
  dark: '어두움',
  error: 'ERROR',

  pingAll: '전체 핑 보내기',
  sendRemoteCommand: '원격 명령 전송',
  restartApp: '앱 재시작',
  stopRecording: '녹화 중지',
  restartAppV3: 'V3 앱 재시작',
  rebootDeviceV3: 'V3 장비 재부팅',
  shutdownDeviceV3: 'V3 장비 종료',
  rollbackDeviceV3: 'V3 장비 롤백',
  agent: '관리 에이전트',
  agentCommandCenter: '관리 에이전트',
  sshControl: 'SSH 제어',
  copyCommand: '접속 커맨드 복사',
  port: '포트',

  enterBarcode: '바코드 입력',
  barcodePlaceholder: '테스트에 사용할 바코드를 입력해 주세요.',

  testAutoRecording: '자동 녹화 테스트',
  testAutoRecordingResult: '자동 녹화 테스트 결과',
  testingAutoRecording: '자동 녹화 테스트 중입니다...',
  testStep: '테스트 단계',
  testStepStatus: '결과',
  elapsedTime: '걸린 시간',
  testDetails: '테스트 상세',
  viewTestCaptureDetails: '테스트 캡쳐 시간보기',
  testCaptureDetails: '테스트 캡쳐 시간',
  captureStartTime: '캡쳐 시작 시간',
  dbCreatedAt: '서버 업로드 시간',

  online: '온라인',
  recordStatus: '녹화 중',
  uploadStatus: '업로드 중',
  sshConnected: 'SSH 연결됨',

  logInquiry: '로그 조회하기',
  syncLog: '로그 반영하기',
  refreshLog: '새로 불러오기',
  requestLog: '로그 요청하기',
  ping: '핑 보내기',
  remainingTime: '{{seconds}}초 후에 다시 시도할 수 있습니다',
  showPreviousImage:
    '새로운 스크린샷을 요청하기까지 {{seconds}}초 남았습니다. 이전 이미지를 표시합니다.',
  more: '더 보기',

  deviceLogExplorer: '디바이스 로그 탐색기',
  selectLogDate: '조회할 로그 날짜 선택',
  totalLog: '전체 로그',
  logByBarcode: '바코드별 로그',
  alertHistory: '알림 내역',
  barcode: '바코드',
  scannedAt: '스캔 시간',
  fileId: '파일 ID',
  scanInfo: '스캔 정보',
  detail: '상세보기',
  time: '시간',
  text: '텍스트',
  copyBarcodeTooltip: '바코드 복사',
  copyBarcodeSuccess: '바코드를 복사했습니다',
  copyBarcodeFail: '바코드 복사에 실패했습니다',
  motionInfo: '모션 정보',
  recordInfo: '녹화 정보',
  uploadInfo: '업로드 정보',
  segment: '분할',
  startTime: '시작시간',
  endTime: '종료시간',
  duration: '길이',
  success: '완료',
  fail: '실패',
  recordingCheck: '영상확인',
  motionCheck: '모션확인',
  recordingsDownload: '다운로드',
  download: '다운로드',
  alertTime: '발생 시각',
  alertSeverityLabel: '심각도',
  alertSeverity: {
    info: '정보',
    warning: '경고',
    error: '오류',
    critical: '중대',
  },
  alertCode: '코드',
  alertMessage: '메시지',
  alertStatusSummary: '상태 요약',
  alertSlackStatus: 'Slack 상태',
  alertSlackLink: 'Slack 링크',
  alertOpenSlack: '열기',
  alertSlackStatusValue: {
    PENDING: '대기',
    SKIPPED: '건너뜀',
    THRESHOLD_SKIPPED: '임계치 미만',
    ROOT_SENT: '채널 메시지',
    THREAD_SENT: '쓰레드',
    FAILED: '실패',
  },
  alertNoData: '알림이 없습니다.',

  failedUploadRecordingDownload: '업로드 실패 초음파 영상 or 모션 영상 다운로드',
  downloadTitle: '다운로드 확인',
  customCropTitle: '크롭 설정',
  recordingScreenSettings: '녹화 화면 설정',
  remoteCommandTitle: '디바이스 원격 명령 전송',
  refreshScreenshot: '스크린샷 새로고침',
  nextScreenshotIn: '다음 스크린샷 요청까지 {{seconds}}초 남았습니다.',
  preset: '프리셋',
  current: '현재',
  selectResolution: '해상도 선택',
  applyResolution: '해상도 적용',
  applyCrop: '크롭 적용',
  noScreenshotData: '스크린샷 데이터가 없습니다',
  failedToLoadScreenshot: '스크린샷을 불러오지 못했습니다',
  loadingScreenshot: '스크린샷 로딩 중...',
  noScreenshotAvailable:
    '실제 화면 이미지가 들어오지 않아 표시할 수 없습니다. 새로고침하거나 문의해주세요',

  name: '이름',
  open: 'Open',
  close: 'Close',
  version: '버전',
  update: '업데이트',
  disconnect: '연결 종료',
  connect: '연결 생성',
  versionPlaceholder: '마미박스 버전 선택',
  silentUpdate: '조용히 업데이트',
  silentUpdateDescription: '에이전트 2.0.0 버전부터 사용 가능',

  remoteScan: '원격 스캔',
  resolution: '해상도',
  resolutionSettings: '해상도 설정',
  crop: '크롭 설정',
  cropSettings: '크롭 설정',
  resetCrop: '크롭 초기화',
  customCrop: '커스텀 크롭 설정',
  category: '유형',
  value: '값',

  selectHospitalMessage: '병원을 선택해 주세요.',
  searchDevicePlaceholder: '장비명 검색',
  unassignedRoomGroup: '병실 없음',
  inactiveDeviceGroup: '비활성 장비',
  cropMessage: '크롭 설정을 변경하시겠습니까?',
  customCropMessage: '커스텀 크롭 설정으로 적용하시겠습니까?',
  customCropError: '커스텀 크롭 설정에 실패했습니다. 확인해주세요.',
  syncLogMessage: '로그를 반영하시겠습니까?',
  sendPingMessage: '핑을 보내시겠습니까?',
  stopRecordingMessage: '녹화를 중지하시겠습니까?',
  restartAppMessage: '앱을 재시작하시겠습니까?',
  resolutionMessage: '해상도를 변경하시겠습니까?',
  remoteScanMessage: '원격 스캔을 하시겠습니까?',
  showScreenshotMessage: '스크린샷을 보시겠습니까?',
  liveMessage: '라이브에 즉시 반영됩니다.',
  noLogMessage: '로그가 없습니다.',
  noEquipmentMessage: '장비를 찾을 수 없습니다.',
  noVideoMessage: '다운로드에 실패했습니다. 영상이 존재하지 않습니다.',
  failDownloadMessage: '다운로드에 실패했습니다. 다시 시도해 주세요.',
  failScreenshotMessage: '스크린샷을 요청하는데 실패했습니다. 이전에 저장된 스크린샷을 표시합니다.',
  noLargeScreenshotAvailable: '큰 스크린샷이 없습니다. 잠시 후 다시 시도해주세요.',
  logRequestSent: '로그 전송 요청됨',
  logRequestMessage:
    '로그 전송이 요청되었습니다.\n장비의 네트워크가 정상이라면 로그를 서버로 전송할 예정입니다.\n10초~1분 후에 "새로 불러오기" 버튼을 눌러주세요.',
  commandNotAvailable: '명령 전송 기능을 사용할 수 없습니다.',
  downloadStartMessage: '다운로드를 클릭하세요',
  agentUpdateMessage: '에이전트 업데이트를 요청했습니다.',
  mommyBoxUpdateMessage1: '마미박스',
  mommyBoxUpdateMessage2: '업데이트를 요청했습니다.',
  sshOrderMessage: '연결을 요청했습니다.',
  sshOrderCloseMessage: '연결 종료를 요청했습니다.',
  rebootDeviceMessage: '장비를 재부팅 하시겠습니까?',
  shutdownDeviceMessage: '장비를 종료 하시겠습니까?',
  rollbackDeviceMessage: '마미박스 버전을 롤백 하시겠습니까?',

  // 리모콘 모달 관련
  textSend: '텍스트 전송',
  textSendPlaceholder: '바코드 또는 명령 입력',
  send: '전송',
  recordingControl: '녹화 제어',
  recordingResume: '녹화 재개',
  recordingPause: '일시정지',
  recordingStop: '녹화 종료',
  recordingCancel: '녹화 취소',
  screenCapture: '화면 캡쳐',
  systemControl: '시스템 제어',
  sendPing: '핑 보내기',
  appRestart: '앱 재시작',
  enterTextMessage: '텍스트를 입력해주세요',
  commandSentMessage: '명령이 전송되었습니다',
  selectDeviceMessage: '장치를 선택해주세요',
  remoteControl: '원격 리모콘',
  recordingStartStop: '녹화시작_녹화종료',
  recordingResumePause: '녹화재개_일시정지',

  // 로그 파서 관련
  logTotalLines: '총 {{count}}개 라인',
  logParsedLines: '파싱됨: {{count}}개',
  logUnparsedLines: '파싱 실패: {{count}}개',

  // 로그 로딩 단계
  logRequesting: '로그 요청중...',
  logDownloading: '로그 다운로드중...',
  logAnalyzing: '로그 분석중...',

  // 로그 검색 관련
  searchLog: '로그 검색',
  searchPlaceholder: '검색할 텍스트를 입력하세요... (5글자 이상, 버튼으로 강제검색 가능)',
  searchResults: '검색 결과: {{current}}/{{total}}',
  noSearchResults: '검색 결과가 없습니다',
  nextResult: '다음 결과',
  previousResult: '이전 결과',

  // RemoteOps additions
  sshOpenRequested: 'SSH 연결 생성 요청됨',
  sshCloseRequested: 'SSH 연결 종료 요청됨',
  sshReconnectRequested: 'SSH 재연결 요청됨',
  failedList: '목록 조회에 실패했습니다',
  failedDownload: '다운로드에 실패했습니다',
  failedDelete: '삭제에 실패했습니다',
  failedDisk: '디스크 정보 조회 실패',
  cleanDone: '정리 완료',
  cleanFailed: '정리 실패',
  failedPm2: '프로세스 정보 조회 실패',
  restarted: '재시작 완료',
  restartFailed: '재시작 실패',
  applied: '적용 완료',
  applyFailed: '적용 실패',
  failedVolume: '볼륨 조회 실패',
  failedSetVolume: '볼륨 설정 실패',
  failedUsb: 'USB 정보 조회 실패',
  patchBoxRequested: '박스 패치 요청됨',
  patchAgentRequested: '에이전트 패치 요청됨',
  patchFailed: '패치 실패',
  factoryResetRequested: '공장 초기화 요청됨',
  factoryResetFailed: '공장 초기화 실패',
  reconnect: '재연결',
  used: '사용됨',
  list: '목록',
  logs: '로그',
  trash: '휴지통',
  cache: '캐시',
  cleanSelected: '선택 정리',
  type: '유형',
  size: '크기',
  modified: '수정일',
  actions: '작업',
  select: '선택',
  autoRefreshIn: '{{seconds}}초 후 자동 새로고침',
  refreshNow: '지금 새로고침',
  disk: '디스크',
  path: '경로',
  usbDevices: 'USB 장치',
  deviceType: {
    LED: 'LED',
    SCANNER: '스캐너',
    FOOTSWITCH: '풋스위치',
    REMOTESWITCH: '리모트',
    CAPTUREBOARD: '캡쳐보드',
  },
  otherDevices: '기타',
  connected: '연결됨',
  disconnected: '연결 안 됨',
  processes: '프로세스',
  uptime: '가동 시간',
  memory: '메모리',
  refreshDevices: '장치 새로고침',
  refreshVolume: '볼륨 새로고침',
  volume: '볼륨',
  unmute: '음소거 해제',
  mute: '음소거',
  apply: '적용',
  patchBox: '박스 패치',
  versionOptional: '버전 (선택사항)',
  patch: '패치',
  patchAgent: '에이전트 패치',
  deleteDbFiles: 'DB 파일 삭제',
  addPath: '경로 추가',
  noPaths: '경로가 없습니다',
  dbDeleted: 'DB 파일 삭제됨',
  factoryReset: '공장 초기화',
  runFactoryReset: '공장 초기화 실행',
  listView: '목록 보기',
  treeView: '트리 보기',
  searchFiles: '파일명 검색',
  deleteFileConfirmTitle: '파일 삭제',
  deleteFileConfirmContent: '정말로 이 파일을 삭제하시겠습니까? (되돌릴 수 없습니다)',
  notConnected: 'SSH 연결되지 않았습니다. 연결 후 이용해 주세요.',
  sshDisconnected: 'SSH 연결이 끊겼습니다. 재연결을 시도하세요.',
  autoDisconnectTitle: '유휴 연결 종료',
  autoDisconnectContent: '1분 동안 활동이 없어 SSH 연결을 종료할까요?',
  quickPaths: '위치',
  basePath: '홈',
  videos: '비디오',
  captures: '캡쳐',
  db: 'DB',
  trashCan: '휴지통',
  connecting: '연결 응답 대기중...',
  connectFailed: 'SSH 연결되지 않았습니다. 연결 후 이용해 주세요.',
  // SSH compact banner statuses
  sshStatusConnected: '연결됨',
  sshStatusConnecting: '연결중',
  sshStatusDisconnected: '연결안됨',
  copySshCommand: '명령 복사',
  sshCopyTooltip: '터미널 접속용 커맨드 복사',
  clearItem: '항목 비우기',
  clearItemConfirmTitle: '항목 비우기',
  clearItemConfirmContent: '{{label}} 폴더의 모든 내용을 삭제하시겠습니까? (되돌릴 수 없습니다)',
  refresh: '새로고침',
  refreshAll: '열린 폴더 모두 새로고침',
  refreshFailed: '새로고침 실패',
  refreshing: '새로고침 중...',
  loading: '로딩중...',
  // Overview loading text shown right after opening Remote Tools
  loadingOverview: '로딩중...',
  autoRefreshPaused: '비활성 상태로 인해 자동 새로고침이 일시정지되었습니다',
  autoRefreshPausedText: '자동 새로고침 일시정지',
  resumeAutoRefresh: '자동 새로고침 재개',
  folderUsage: '폴더별 사용량',
  temperature: '온도',

  // System Information Card Titles
  systemOverview: '시스템 개요',
  hardware: '하드웨어',
  software: '소프트웨어',
  volumeControl: '볼륨 제어',
  networkInterfaces: '네트워크 인터페이스',
  audioRecording: '음성녹음장치',
  audioPlayback: '음성재생장치',
  systemInfoRefreshed: '시스템 정보가 새로고침되었습니다',
  systemInfoRefreshFailed: '시스템 정보 새로고침에 실패했습니다',

  // Remote Tools 및 Remote Ops 관련
  remoteTools: '원격 도구',
  overview: '개요',
  files: '파일 탐색기',
  system: '시스템',
  copyFailed: '복사에 실패했습니다',
  noVolumeInfo: '볼륨 정보가 없습니다',
  noRecordingDevices: '녹음 장치가 없습니다',
  noPlaybackDevices: '재생 장치가 없습니다',
  noUsbDevicesDetected: 'USB 장치가 감지되지 않았습니다',
  active: '활성',
  inactive: '비활성',

  // 항목 비우기 관련
  cleanSuccess: '비우기 성공',
  cleanSuccessDetails: '선택한 항목이 성공적으로 비워졌습니다.',
  deletedFiles: '삭제된 파일 수',
  freedSpace: '확보된 용량',
  totalFiles: '총 파일 수',
  totalSize: '총 용량',
  showDetails: '상세보기',
  hideDetails: '접기',
  fileName: '파일명',
  fileSize: '파일 크기',
  fileType: '유형',
  directory: '디렉토리',
  file: '파일',
  video: '영상',
  capture: '캡쳐',
  other: '기타',

  // 다운로드 관리자
  downloadManager: '다운로드 관리자',
  downloadStarted: '다운로드가 시작되었습니다!',
  downloadStartFailed: '다운로드 시작에 실패했습니다.',
  downloadStarting: '다운로드를 시작하고 있습니다...',
  deviceNameRequired: '장비명이 필요합니다.',
  estimatedTime: '예상 소요 시간: {{time}}분',
  useLargeFileDownload: '큰 파일은 다운로드 관리자를 통해 다운로드됩니다.',
  downloadFile: '파일 다운로드',
  activeDownloads: '진행 중',
  completed: '완료',
  activeDownloadsCount: '진행 중: {{count}}개',
  completedDownloadsCount: '완료: {{count}}개',
  noActiveDownloads: '진행 중인 다운로드가 없습니다',
  downloadStatusPreparing: '준비 중',
  downloadStatusUploading: '업로드 중',
  downloadStatusCompleted: '완료',
  downloadStatusFailed: '실패',
  downloadStatusExpired: '만료',
  filePath: '파일',
  status: '상태',
  progress: '진행률',
  createdAt: '시작 시간',

  // 다운로드 삭제 관련
  deleteDownload: '다운로드 삭제',
  deleteDownloadConfirm: '다운로드를 삭제하시겠습니까?',
  deleteDownloadConfirmDescription: '이 작업은 되돌릴 수 없습니다.',
  downloadDeleted: '다운로드가 삭제되었습니다',
  downloadDeleteFailed: '다운로드 삭제에 실패했습니다:',

  // SSH 연결 관련 메시지
  connectionRequired: '원격 도구 사용을 위해 SSH 연결이 필요합니다.',
  selectHostAndConnect: 'SSH 호스트를 선택하고 연결 버튼을 클릭하세요.',
  loadingDeviceInfo: '디바이스 정보를 불러오는 중...',

  // 파일 다운로드 관련
  downloadProgress: '다운로드 중',
  downloadReady: '파일 다운로드가 완료되었습니다.',
  unknownSize: '알 수 없음',
  fileNotFound: '파일 정보를 찾을 수 없습니다.',
  unknownFileSize: '파일 크기를 확인할 수 없습니다.',
  chunkSizeMismatch: '청크 크기가 일치하지 않습니다. 다시 시도해주세요.',
  largeFileDownloadConfirmTitle: '큰 파일 다운로드',
  largeFileDownloadConfirmContent:
    '파일 크기가 {{size}}로 5MB를 초과합니다.\n다운로드 센터를 통해 다운로드를 시작하시겠습니까?\n\n다운로드 센터에서 진행 상황을 확인할 수 있습니다.',
  downloadCenterNotice: '다운로드 센터를 통한 다운로드를 시작합니다.',
  sshOrderError: 'SSH 연결 요청 중 오류가 발생했습니다.',
};

export default monitoringTranslation;
